import React from "react";
import * as Icon from "react-feather";

// Définir des sous-menus communs
const dashboardsSubmenuItems = [
  // { label: "Tableau de bord Admin", link: "/admin-dashboard" },
  { label: "Tableau de bord des ventes", link: "/sales-dashboard" },
  { label: "Utilisateurs", link: "/users" },

];


const inventorySubmenuItems = [
  { label: "Produits", link: "/product-list", icon: <Icon.Box />, submenu: false },
  { label: "Ajouter un produit", link: "/add-product", icon: <Icon.PlusSquare />, submenu: false },
  { label: "Produits expirés", link: "/expired-products", icon: <Icon.Codesandbox />, submenu: false },
  { label: "Stocks faibles", link: "/low-stocks", icon: <Icon.TrendingDown />, submenu: false },
  { label: "Catégories", link: "/category-list", icon: <Icon.Codepen />, submenu: false },
  // { label: "Sous-catégorie", link: "/sub-categories", icon: <Icon.Speaker />, submenu: false },
  // { label: "Marques", link: "/brand-list", icon: <Icon.Tag />, submenu: false },
  { label: "Unités", link: "/units", icon: <Icon.Speaker />, submenu: false },
  // { label: "Garanties", link: "/warranty", icon: <Icon.Bookmark />, submenu: false },
];

// Structure principale
export const SidebarData = [
  {
    module: "admin-dashboard",
    label: "Principal",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Tableau de bord",
        icon: <Icon.Grid />,
        submenu: true,
        showSubRoute: false,
        submenuItems: dashboardsSubmenuItems, 
      },
    ],
  },
  {
    module: "sales-dashboard",
    label: "Principal",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Tableau de bord",
        icon: <Icon.Grid />,
        submenu: true,
        showSubRoute: false,
        submenuItems: dashboardsSubmenuItems, 
      },
    ],
  },
  {
    module: "users",
    label: "Principal",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Gérer les utilisateurs",
        icon: <Icon.Grid />,
        submenu: true,
        showSubRoute: false,
        submenuItems: dashboardsSubmenuItems, 
      },
    ],
  },
 
  {
    module: "product-list",
    label: "Inventaire",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventaire",
    submenuItems: inventorySubmenuItems, 
  },
  {
    module: "add-product",
    label: "Inventaire",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventaire",
    submenuItems: inventorySubmenuItems, 
  },
  {
    module: "expired-products",
    label: "Inventaire",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventaire",
    submenuItems: inventorySubmenuItems, 
  },
  {
    module: "move-stock",
    label: "Inventaire",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventaire",
    submenuItems: inventorySubmenuItems, 
  },
  {
    module: "low-stocks",
    label: "Inventaire",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventaire",
    submenuItems: inventorySubmenuItems, 
  },
  {
    module: "category-list",
    label: "Inventaire",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventaire",
    submenuItems: inventorySubmenuItems, 
  },
  {
    module: "units",
    label: "Inventaire",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventaire",
    submenuItems: inventorySubmenuItems, 
  },
 
      
];
